import {EntitaOrganizzativa} from '../entitaorganizzativa/entitaorganizzativa.model';
import {TreeViewNode} from './tree-view/model/tree-view-node-default.model';
import {Helpers} from '../../common/helpers/helpers';

export class TreeViewNodeAce extends TreeViewNode {

  // custom fields
  public entity: EntitaOrganizzativa;

  public gerarchiaLabel: string;
  public gerarchiaFrom: Date;
  public gerarchiaTo: Date;
  public gerarchiaId: number;
  public figlioGuida: boolean;

  public structError: boolean;
  public dateError: boolean;

  public eoPathTop: boolean;
  public eoPathBottom: boolean;
  public eoNode: boolean;

  public delegabile: boolean;

  public tipoGerarchiaId: number;
  public dataRif: Date;

  /**
   * Filter condition override.
   * @param term
   * @returns {boolean}
   */
  protected filterCondition(term): boolean {

    const tokens = term.toLowerCase().split(' ');

    let finded = true;

    tokens.forEach( (token) => {
      if (!finded) {
        return;
      }
      if (this.entity.denominazione && this.entity.denominazione.toLowerCase().indexOf(token) !== -1) {
        return;
      }
      if (this.entity.sigla && this.entity.sigla.toLowerCase().indexOf(token) !== -1) {
        return;
      }
      if (this.entity.indirizzoPrincipale && this.entity.indirizzoPrincipale.comune
        &&  this.entity.indirizzoPrincipale.comune.toLowerCase().indexOf(token) !== -1) {
        return;
      }
      if (this.entity.idnsip && this.entity.idnsip.toLowerCase().indexOf(token) !== -1) {
        return;
      }
      if (this.entity.cdsuo && this.entity.cdsuo.toLowerCase().indexOf(token) !== -1) {
        return;
      }


      finded = false;
    });

    return finded;
  }

  public getDataRif() {
    return Helpers.formatDate(this.dataRif);
  }

}
